// extracted by mini-css-extract-plugin
export default {"main":"Navigation_main__BF4q1","button":"Navigation_button__Apidt","icon":"Navigation_icon__9SXWl"};